var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"favourite_page"},[_c('v-container',[_c('div',{staticClass:"__bread mt-5"},[_c('v-breadcrumbs',{attrs:{"items":_vm.Bread}})],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"3"}},[_c('filterFav')],1),_c('v-col',{attrs:{"cols":"12","lg":"9"}},[_c('studios')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }